import { render, staticRenderFns } from "./CompanyCompanyCurrency.vue?vue&type=template&id=f223c294"
import script from "./CompanyCompanyCurrency.vue?vue&type=script&lang=js"
export * from "./CompanyCompanyCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports